import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileManagementComponent } from './features/auth/profile-management/profile-management.component';
import { ErrorComponent } from './features/pages/error/error.component';
import { TopRestaurantByOrdersComponent } from './features/reports/components/top-restaurant-by-orders/top-restaurant-by-orders.component';
import { AuthGuard } from './helpers/auth.guard';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { BasicLayoutComponent } from './layouts/basic-layout/basic-layout.component';
import { EmptyLayoutComponent } from './layouts/empty-layout/empty-layout.component';

const routes: Routes = [
  {
    path: '',
    component: BasicLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) }
    ]
  },
  {
    path: 'admin/floorPlan',
    component: EmptyLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./features/floor-plan/floor-plan.module').then(m => m.FloorPlanModule) },
    ]
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: (localStorage.getItem('baseRoute') || ''), pathMatch: 'full' },
      { path: 'profile', component: ProfileManagementComponent },
      { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'guestList', loadChildren: () => import('./features/guests/guests.module').then(m => m.GuestsModule) },
      { path: 'roles', loadChildren: () => import('./features/roles/roles.module').then(m => m.RolesModule) },
      { path: 'restaurants', loadChildren: () => import('./features/restaurants/restaurants.module').then(m => m.RestaurantsModule) },
      { path: 'SystemTeam', loadChildren: () => import('./features/Accounts/diwan-team/diwan-team.module').then(m => m.DiwanTeamModule) },
      { path: 'RestaurantStaff', loadChildren: () => import('./features/Accounts/restaurant-staff/restaurant-staff.module').then(m => m.RestaurantStaffModule) },
      {
        path: 'configrations',
        children: [
          { path: 'cuisines', loadChildren: () => import('./features/configrations/cuisines/cuisines.module').then(m => m.CuisinesModule) },
          { path: 'seatings', loadChildren: () => import('./features/configrations/seatings/seatings.module').then(m => m.SeatingsModule) },
          { path: 'amenities', loadChildren: () => import('./features/configrations/amenities/amenities.module').then(m => m.AmenitiesModule) },
          { path: 'MeasurementUnits', loadChildren: () => import('./features/configrations/measurement-units/measurement-units.module').then(m => m.MeasurementUnitsModule) },
          { path: 'sizes', loadChildren: () => import('./features/configrations/sizes/sizes.module').then(m => m.SizesModule) },
          { path: 'payment', loadChildren: () => import('./features/configrations/payment/payment.module').then(m => m.PaymentModule) },
          { path: 'reviewOptions', loadChildren: () => import('./features/configrations/review-options/review-options.module').then(m => m.ReviewOptionsModule) },
        ]
      },
      {
        path: 'ingConfigrations',
        children: [
          { path: 'MeasurementUnits', loadChildren: () => import('./features/configrations/measurement-units/measurement-units.module').then(m => m.MeasurementUnitsModule) },
          { path: 'IngredientsCategory', loadChildren: () => import('./features/configrations/ingredients-category/ingredients-category.module').then(m => m.IngredientsCategoryModule) },
          { path: 'Ingredients', loadChildren: () => import('./features/configrations/ingredients/ingredients.module').then(m => m.IngredientsModule) },
        ]
      },
      { path: 'vouchers', loadChildren: () => import('./features/vouchers/vouchers.module').then(m => m.VouchersModule) },
      {
        path: 'reward-points',
        children: [
          { path: 'reward-points-config', loadChildren: () => import('./features/reward-points/reward-points-config/reward-points-config.module').then(m => m.RewardPointsConfigModule) },
          { path: 'redeeming', loadChildren: () => import('./features/reward-points/redeeming/redeeming.module').then(m => m.RedeemingModule) }
        ]
      },
      {
        path: 'menu-management',
        children: [
          { path: 'menus', loadChildren: () => import('./features/menu-management/menus/menus.module').then(m => m.MenusModule) },
          { path: 'modifiers', loadChildren: () => import('./features/menu-management/modifiers/modifiers.module').then(m => m.ModifiersModule) }
        ]
      },
      {
        path: 'stock-management',
        children: [
          { path: 'suppliers', loadChildren: () => import('./features/Stock Management/suppliers/suppliers.module').then(m => m.SuppliersModule) },
          { path: 'stock-transaction', loadChildren: () => import('./features/Stock Management/stock-transaction/stock-transaction.module').then(m => m.StockTransactionModule) }
        ]
      },
      { path: 'reports', loadChildren: () => import('./features/reports/reports.module').then(m => m.ReportsModule) },
      { path: 'guestAppManage', loadChildren: () => import('./features/guest-app-manage/guest-app-manage.module').then(m => m.GuestAppManageModule) },
      { path: 'reported-content', loadChildren: () => import('./features/reported-content/reported-content.module').then(m => m.ReportedContentModule) },
      { path: 'guests-reviews', loadChildren: () => import('./features/guests-reviews/guests-reviews.module').then(m => m.GuestsReviewsModule) },
      { path: 'reportedReservations', loadChildren: () => import('./features/reported-reservations/reported-reservations.module').then(m => m.ReportedReservationsModule) },
      { path: '**', component: ErrorComponent }
    ]
  },
  { path: '**', component: ErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
